/**
 * SPA에 실제로 정의된 경로가 아닌 값이 redirectAfterLogin 등에 들어가면
 * 로그인 직후 404가 납니다. 동일 출처의 상대 경로만 허용하고, 없는 라우트로
 * 쓰이던 경로는 홈으로 대체합니다.
 */

const INVALID_LOGIN_RELATED = new Set([
  '/login',
  '/register',
  '/find-password',
  '/oauth/callback',
  '/2fa-verify',
]);

function pathAndSearchOnly(value) {
  const s = String(value).trim();
  if (!s) return '';
  try {
    if (/^https?:\/\//i.test(s)) {
      const u = new URL(s);
      if (typeof window !== 'undefined' && u.origin !== window.location.origin) {
        return '';
      }
      return `${u.pathname}${u.search}`;
    }
  } catch {
    return '';
  }
  if (!s.startsWith('/') || s.startsWith('//')) return '';
  const q = s.indexOf('?');
  const h = s.indexOf('#');
  if (h !== -1 && (q === -1 || h < q)) {
    return s.slice(0, h);
  }
  return s;
}

function pathnameOnly(pathWithSearch) {
  const q = pathWithSearch.indexOf('?');
  return q === -1 ? pathWithSearch : pathWithSearch.slice(0, q);
}

/**
 * @param {string | null | undefined} raw
 * @param {{ defaultPath?: string }} [options]
 * @returns {string}
 */
export function getSafePostLoginRedirect(raw, options = {}) {
  const defaultPath = options.defaultPath ?? '/';
  const combined = pathAndSearchOnly(raw || '');
  if (!combined) return defaultPath;

  const path = pathnameOnly(combined);
  if (INVALID_LOGIN_RELATED.has(path)) return defaultPath;

  return combined;
}
